var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"configurationReport"},[_c('iframe',{attrs:{"src":_vm.reportUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }